import React, { createContext, useContext, useMemo } from 'react';

import { Configuration } from '../../config';
import { Config } from '../../models';

const ConfigContext = createContext<Config>({} as Config);

// TODO: Inject settings into this component
export const ConfigProvider: React.FC<any> = ({ children }) => {
  const value = useMemo(() => {
    const configuration = new Configuration();

    return {
      ...configuration.config,
      CONFIG_INSTANCE: configuration,
    };
  }, []);

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
